import axios from "axios";

export default function requestConfigResult(
  baseRestUrl,
  context,
  marketCode,
  selectedValues,
  pricingInfo,
  callBack,
  comStatusCallback,
  comStatus
) {
  const url = `${baseRestUrl}/configresult/${context}?marketCode=${marketCode}`;
  const body = {
    chosenValues: selectedValues,
    pricingInfo,
  };
  const headers = {
    "Content-Type": "application/json",
  };

  axios
    .post(url, body, { headers })
    .then(response => {
      if (response.status === 200) {
        callBack(response.data, selectedValues);
      }

      comStatus.prices.status = response.status;
      comStatus.prices.message = response.statusText;
      comStatusCallback(comStatus);
    })
    .catch(() => {
      comStatus.prices.status = 500;
      comStatus.prices.message = "Error (requestConfigResult)";
      comStatusCallback(comStatus);
    });
}
